var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C7.3625 0 8.1125 0.485156 8.48984 1.19766C9.26094 0.960937 10.1328 1.14844 10.7422 1.75781C11.3516 2.36719 11.5391 3.24141 11.3023 4.01016C12.0148 4.3875 12.5 5.1375 12.5 6C12.5 6.8625 12.0148 7.6125 11.3023 7.98984C11.5391 8.76094 11.3516 9.63281 10.7422 10.2422C10.1328 10.8516 9.25859 11.0391 8.48984 10.8023C8.1125 11.5148 7.3625 12 6.5 12C5.6375 12 4.8875 11.5148 4.51016 10.8023C3.73906 11.0391 2.86719 10.8516 2.25781 10.2422C1.64844 9.63281 1.46094 8.75859 1.69766 7.98984C0.985156 7.6125 0.5 6.8625 0.5 6C0.5 5.1375 0.985156 4.3875 1.69766 4.01016C1.46094 3.23906 1.64844 2.36719 2.25781 1.75781C2.86719 1.14844 3.74141 0.960937 4.51016 1.19766C4.8875 0.485156 5.6375 0 6.5 0ZM9.14844 4.89844C9.36875 4.67812 9.36875 4.32188 9.14844 4.10391C8.92813 3.88594 8.57188 3.88359 8.35391 4.10391L5.75234 6.70547L4.65078 5.60391C4.43047 5.38359 4.07422 5.38359 3.85625 5.60391C3.63828 5.82422 3.63594 6.18047 3.85625 6.39844L5.35625 7.89844C5.57656 8.11875 5.93281 8.11875 6.15078 7.89844L9.14844 4.89844Z",
    fill: "#1C38F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ea5da96d105f2041bd49721b79efb330.svg";
export { ForwardRef as ReactComponent };